import { Component, OnInit } from '@angular/core';
import { CoursesComponent } from '../courses.component';

@Component({
    selector: 'app-published',
    templateUrl: './published.component.html',
    styleUrls: ['./published.component.scss'],
    imports: [CoursesComponent]
})
export class PublishedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
